import ExportMembersPage from "../../exportMembers/ExportMembersPage";

export default [
  {
    value: "CLIENTS",
    key: "importExport.exportTypes.client",
    component: ExportMembersPage,
  },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/enums/exportPageTypes.js